import { SnapshotIn, types } from 'mobx-state-tree';
export const Organization = types.model({
  id: types.string,
  default: types.boolean,
  name: types.maybeNull(types.string),
});

export interface Organization extends SnapshotIn<typeof Organization> {}
